<mat-accordion multi>
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title [ngClass]="{active:value.category_ids.length>0}">
        Category
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-product-category-checker [(ngModel)]="value.category_ids" (ngModelChange)="onValueChanged()"
      [disabled]="disabled"></app-product-category-checker>
  </mat-expansion-panel>

  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title [ngClass]="{active:value.tags.length>0}">
        Purpose
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-product-tag-checker [(ngModel)]="value.tags" (ngModelChange)="onValueChanged()"
      [disabled]="disabled"></app-product-tag-checker>
  </mat-expansion-panel>
  <mat-expansion-panel [expanded]="value.sizes.length>0">
    <mat-expansion-panel-header>
      <mat-panel-title [ngClass]="{active:value.sizes.length>0}">
        Clothing Size
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-product-size-checker [(ngModel)]="value.sizes" (ngModelChange)="onValueChanged()"
      [disabled]="disabled"></app-product-size-checker>
  </mat-expansion-panel>
  <mat-expansion-panel [expanded]="value.color.length>0">
    <mat-expansion-panel-header>
      <mat-panel-title [ngClass]="{active:value.color}">
        Color
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-product-color-picker [(ngModel)]="value.color" (ngModelChange)="onValueChanged()"
      [disabled]="disabled"></app-product-color-picker>
  </mat-expansion-panel>
</mat-accordion>